module.exports = "./img/c92191394b8fc8644fd3fefac8642ed4.jpg";